module.exports = __webpack_public_path__ + "static/media/logo.b4887db7.svg";